<div class="ctb-slider" [style.--ctb-slider-progress]="progressPercent()">
	@if (state().label !== "") {
		<label class="ctb-slider__label" [attr.for]="state().id || null">{{ state().label }}</label>
	}

	<div class="ctb-slider__control">
		<div
			class="ctb-slider__tooltip"
			[attr.aria-hidden]="!state().tooltipVisible"
			[class.ctb-slider__tooltip--visible]="state().tooltipVisible"
		>
			{{ formattedValue() }}
		</div>

		<input
			class="ctb-slider__input"
			type="range"
			[attr.aria-label]="resolvedAriaLabel()"
			[attr.aria-valuemax]="state().max"
			[attr.aria-valuemin]="state().min"
			[attr.aria-valuenow]="state().value"
			[attr.aria-valuetext]="formattedValue()"
			[attr.id]="state().id"
			[max]="state().max"
			[min]="state().min"
			[step]="state().step"
			[value]="state().value"
			(blur)="onTooltipVisibilityChange(false)"
			(focus)="onTooltipVisibilityChange(true)"
			(input)="onValueInput($event)"
			(mouseenter)="onTooltipVisibilityChange(true)"
			(mouseleave)="onTooltipVisibilityChange(false)"
			(touchstart)="onTooltipVisibilityChange(true)"
			(touchend)="onTooltipVisibilityChange(false)"
		/>
	</div>

	<div class="ctb-slider__markers" aria-hidden="true">
		<span>{{ formattedMin() }}</span>
		<span>{{ formattedMax() }}</span>
	</div>
</div>
